// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_gV","advertCardPhoto__image":"c-a_gW"};